/**
 * @description Класс отвечает за логику работы всей секции с формой пассажира
 * */
class PassengerFormController {
    class = {
        passenger_form_modal: "passenger-form-modal"
    };
    selectors = {
        form_header_title: ".js-form-section-title",
        passenger_form_body: ".js-passenger-form-body",
        error_visible_first: ".error:visible:first",
        passenger_form_toggle: ".js-passenger-form-toggle"
    };

    constructor($wrapper, options) {
        const that = this;

        // DOM
        that.$wrapper = $wrapper;
        that.$form_body = that.$wrapper.find(that.selectors.passenger_form_body);
        that.form_body_html = that.$form_body[0].outerHTML;

        /**
         * @type {PageSearchPassengers}
         * */
        that.page_controller = options["page_controller"];

        // Const
        that.locales = that.page_controller.locales;
        that.category = that.$wrapper.data("category");
        that.passenger_index = options["passenger_index"];
        that.is_infant = options["is_infant"];

        //
        /** @type {?PassengerForm} */
        that.form = null;
        /** @type {?PassengerFormToggle} */
        that.toggle = null;
        that.watcher = null;

        // Init
        that.init();
    }

    init() {
        const that = this;

        /**
         * @type {PassengerForm}
         * @description Инициируем логику работы полей внутри формы
         * */
        that.form = that.#initFormBody(that.$form_body);

        /**
         * @description обновление данных в toggle при изменении данных на десктопе
         * таймер для оптимизации
         * */
        let update_timeout = 0;
        that.$form_body.on("change", function() {
            clearTimeout(update_timeout);
            update_timeout = setTimeout( function() {
                that.#updateToggleData();
            }, 100);
        });

        /**
         * @description Переключатель редактирования пассажира для телефонов
         * Нужно чтобы скрипты страницы отработали ДО, поэтому таймер
         * */
        setTimeout( function() {
            that.toggle = that.#initFormToggle();
        }, 50);

        that.$wrapper.data("passenger_form_controller", that);
    }

    async showFormBodyAtModal() {
        const that = this;

        const header_title = that.$wrapper.find(that.selectors.form_header_title).text(),
              button_confirm_text = that.locales["apply"],
              desktop_ssrs_data = that.form.getSsrs(),
              desktop_form_data = that.form.getData();

        let modal_form = null;

        return new Promise( function(resolve) {
            $.uiDrawer({
                header_title: header_title,
                content: that.form_body_html,
                mobile_fullscreen: true,
                button_align_center: true,
                button_confirm_text: button_confirm_text,
                custom_class: that.class.passenger_form_modal,
                onOpen: function($modal, controller) {
                    const $form_body = $modal.find(that.selectors.passenger_form_body);
                    modal_form = that.#initFormBody($form_body, true);
                    modal_form.setData(desktop_form_data, false);
                    modal_form.setSSRS(desktop_ssrs_data);
                    resolve({ $modal, modal_form });

                    // Запускаем смотрителя, который закроет диалог на десктопе при ресайзе окна 
                    if (that.watcher) { that.watcher.destroy(); }
                    that.watcher = initResizeWatcher($modal, controller);
                },
                onClose: function() {
                    if (that.watcher) { that.watcher.destroy(); }
                },
                onButtonConfirmClick: function(modal) {
                    const validation = modal_form.isValid(that.page_controller.departure_date, that.page_controller.departure_date_last);
                    if (!validation) {
                        // Там идёт параллельный рендер ошибок. Нужно запустить скролл в отдельном потоке
                        setTimeout( function() {
                            const $target = modal.$wrapper.find(that.selectors.error_visible_first);
                            if ($target.length) {
                                $target[0].scrollIntoView({ block: "center", behavior: "smooth" });
                            }
                        }, 50);

                        return false;
                    } else {
                        const ssrs_data = modal_form.ssrs_data,
                              form_data = modal_form.getData();

                        that.#updateFormData(form_data, ssrs_data);
                    }
                }
            });
        });

        function initResizeWatcher($wrapper, controller) {
            const $window = $.sa.$window;

            $window.on("resize", resizeWatcher);

            return {
                destroy: destroy
            };

            function resizeWatcher() {
                const is_exist = $.contains(document, $wrapper[0]);
                if (is_exist) {
                    if ($.sa.is_desktop()) {
                        controller.close();
                    }
                } else {
                    destroy();
                }
            }

            function destroy() {
                $window.off("resize", resizeWatcher);
                that.watcher = null;
            }
        }
    }

    //

    /**
     * @description Инициируем логику кнопки для мобильных телефонов
     * */
    #initFormToggle() {
        const that = this;

        // DOM
        const $wrapper = that.$wrapper,
              $toggle = $wrapper.find(that.selectors.passenger_form_toggle);

        const form_data = that.form.getData();

        /** @type {PassengerFormToggle} */
        return new PassengerFormToggle($toggle, {
            data: form_data,
            locales: that.locales,
            onClick: function() {
                that.showFormBodyAtModal();
            }
        });
    }

    /**
     * @param {jQuery} $form_body
     * @param {Boolean?} is_modal
     * */
    #initFormBody($form_body, is_modal) {
        is_modal = (typeof is_modal === "boolean" ? is_modal : false);

        const that = this;

        const options = {
            form_controller    : that,
            is_modal           : is_modal,
            category           : that.category,
            is_infant          : that.is_infant,
            passenger_index    : that.passenger_index,
            contact_documents  : that.page_controller.contact_documents,
            modals             : that.page_controller.modals['passenger_form'],
            departure_date     : that.page_controller.departure_date,
            departure_date_last: that.page_controller.departure_date_last,
            locales            : that.page_controller.locales['passenger_form'],
            getSsrs            : function () {
                return that.page_controller.__getPassengerSsrs(that.passenger_index);
            },
            getMaxSsrIndex     : function () {
                return that.page_controller.__getMaxSsrIndex();
            }
        }

        return new PassengerForm($form_body, options);
    }

    /**
     * @description Обновляем модель данных формы используя данные из модального окна
     * */
    #updateFormData(form_data, ssrs_data) {
        const that = this;
        that.form.setData(form_data);
        that.form.setSSRS(ssrs_data);
        that.toggle.set(form_data);
    }

    /**
     * @description Обновляем данные в toggle из формы
     * */
    #updateToggleData() {
        const that = this,
              form_data = that.form.getData();
        that.toggle.set(form_data);
    }
}